import { FetchHttpClient } from '../transport/http';
import { Source } from './source';

/**
 Defaults for Experiment Config options

 | **Option**       | **Default**                       |
 |------------------|-----------------------------------|
 | **debug**        | `false`                           |
 | **instanceName** | `$default_instance` |
 | **fallbackVariant**         | `null`                 |
 | **initialVariants**         | `null`                 |
 | **source** | `Source.LocalStorage` |
 | **serverUrl**    | `"https://api.lab.amplitude.com"` |
 | **assignmentTimeoutMillis**    | `10000` |
 | **retryFailedAssignment**    | `true` |
 | **automaticExposureTracking** | `true` |
 | **automaticFetchOnAmplitudeIdentityChange** | `false` |
 | **userProvider**    | `null` |
 | **analyticsProvider**    | `null` |
 | **exposureTrackingProvider**    | `null` |

 *
 * @category Configuration
 */
export const Defaults = {
  debug: false,
  instanceName: '$default_instance',
  fallbackVariant: {},
  initialVariants: {},
  source: Source.LocalStorage,
  serverUrl: 'https://api.lab.amplitude.com',
  fetchTimeoutMillis: 10000,
  retryFetchOnFailure: true,
  automaticExposureTracking: true,
  automaticFetchOnAmplitudeIdentityChange: false,
  userProvider: null,
  exposureTrackingProvider: null,
  httpClient: FetchHttpClient
};
//# sourceMappingURL=config.js.map